module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-page"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "contacts-page__main"
  }, [_c('div', {
    staticClass: "contacts-page__container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isFormOpened) ? _c('ul', {
    staticClass: "contacts-list"
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('li', {
      ref: "contacts",
      refInFor: true,
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "contact__label"
    }, [_vm._v(_vm._s(contact.label))]), _c('div', {
      staticClass: "contact__value"
    }, [_vm._v(_vm._s(contact.content))]), (!_vm.isFormOpened && contact.url.length > 0 && contact.labelUrl.length > 0) ? _c('base-button', {
      ref: "mapButton",
      refInFor: true,
      staticClass: "map-link",
      attrs: {
        "url": contact.url,
        "label": contact.labelUrl
      }
    }) : _vm._e()], 1)
  })) : _vm._e()])], 1)]), (this.windowWidth > 1024) ? _c('div', {
    staticClass: "contacts-page__aside aside-container"
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('div', {
    ref: "background",
    staticClass: "aside-inner__background",
    class: {
      'is-wide': _vm.isFormOpened
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isFormOpened) ? _c('button', {
    ref: "button",
    staticClass: "trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('div', {
    staticClass: "trigger__wrap"
  }, [_c('img', {
    staticClass: "trigger__icon",
    attrs: {
      "src": require("../../assets/form-icon.svg"),
      "alt": "form icon"
    }
  }), _c('span', {
    staticClass: "trigger__label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('write-to-us'))
    }
  })])]) : _vm._e()])], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf5cb6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/index.vue
// module id = 503
// module chunks = 0